import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  icon: {
    fontSize: 19, // TODO - fix нет в токенах
    width: theme.px(20),
    height: theme.px(20),
  },
}));
